import React from 'react';

const FormSkeleton: React.FC = () => (
  <div className="w-full h-full animate-pulse">
    <div className="glass-surface p-4 rounded-3xl">
      <div className="space-y-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="space-y-2">
            <div className="h-5 w-1/3 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            <div className="h-12 w-full bg-neutral-200 dark:bg-neutral-700 rounded-3xl" />
          </div>
        ))}
      </div>
      <div className="flex flex-col md:flex-row items-start mt-8 gap-4">
        <div className="h-12 w-48 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" />
        <div className="h-12 w-48 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" />
      </div>
    </div>
  </div>
);

export default FormSkeleton;
